import React from 'react';
import Plot from 'react-plotly.js';

const CostPlot = ({ clinicalAssessmentCost, prescreeningCost, otherPrescreeningCost, screeningCost, finalTP, prevalence, sensitivity, specificity, clinicalAssessmentTiming }) => {
    const sampleSizeStep1 = Math.ceil(finalTP / (sensitivity * prevalence));
    const sampleSizeStep2 = Math.ceil((sensitivity * prevalence + (1 - specificity) * (1 - prevalence)) * sampleSizeStep1);
    const screeningSize = Math.ceil(finalTP / prevalence);

    // Calculate costs
    const costsNoPrescreening = [
        clinicalAssessmentCost * screeningSize,
        0,
        screeningCost * screeningSize
    ];
    const costsCustom = [
        clinicalAssessmentCost * (clinicalAssessmentTiming == "before" ? sampleSizeStep1 : sampleSizeStep2),
        prescreeningCost * sampleSizeStep1,
        screeningCost * sampleSizeStep2
    ];

    // Total costs for comparison
    const totalNoPrescreening = costsNoPrescreening.reduce((a, b) => a + b, 0);
    const totalCustom = costsCustom.reduce((a, b) => a + b, 0);

    // Calculate percentage difference
    const percentageDifference = ((totalCustom / totalNoPrescreening) - 1) * 100;

    // Plot data
    const data = [
        {
            x: ['No Pre-screening', 'Pre-screening'],
            y: [costsNoPrescreening[0], costsCustom[0]],
            name: 'Clinical Assessment',
            type: 'bar',
            marker: { color: '#e3cfab' }
        },
        {
            x: ['No Pre-screening', 'Pre-screening'],
            y: [costsNoPrescreening[1], costsCustom[1]],
            name: 'Pre-screening',
            type: 'bar',
            marker: { color: '#f2ece1' }
        },
        {
            x: ['No Pre-screening', 'Pre-screening'],
            y: [costsNoPrescreening[2], costsCustom[2]],
            name: 'Screening',
            type: 'bar',
            marker: { color: '#889c9d' }
        },
    ];

    // Define annotations
    const annotations = [
        {
            x: 'Pre-screening',
            y: Math.max(...[...costsNoPrescreening, ...costsCustom]),
            text: `${percentageDifference.toFixed(2)}%`,
            showarrow: false,
            font: {
                family: 'Roboto, sans-serif',
                size: 14,
                color: 'black',
            },
            xref: 'x',
            yref: 'y',
            align: 'center',
        }
    ];
    
    return <Plot
        data={data}
        layout = {{
            barmode: 'stack',
            yaxis: { title: 'Cost' },
            margin: { l: 50, r: 0, b: 0, t: 0, pad: 0 },
            legend: { orientation: 'h', x: 0.5, xanchor: 'center' },
            autosize: true,
            height: 400,
            //annotations: annotations,
        }}
        useResizeHandler={true}
        style={{ width: "100%" }}
    />;
};

export default CostPlot;
